module.exports = __webpack_public_path__ + "img/envelope.be5c7a7a.svg";